import { ReactComponent as GeneratorIcon } from 'assets/generator.svg';
import { GeneratorData } from '../domain/types';
import PercentageBar from './PercentageBar';

const GeneratorCard = ({ generatorItem }: { generatorItem: GeneratorData }) => {
  const colors = {
    Active: '#99D633',
    Reserved: 'gray',
    Maintenance: 'orange'
  };

  function parsePercentage(value: string): number {
    // Remove the '%' sign and convert to float
    const num = parseFloat(value.replace('%', ''));
    // Return the integer part
    return Math.floor(num);
  }

  return (
    <div className='bg-dark p-2 w-[160px] 2xl:w-[200px] h-[230px] 2xl:h-[300px]'>
      <div className='flex flex-col justify-center items-center'>
        <h3 className='text:lg 2xl:text-2xlfont-bold'>{generatorItem.title}</h3>
        <div className='p-2 flex flex-col gap-2 w-[85%] 2xl:w-full'>
          <GeneratorIcon style={{ color: colors[generatorItem.status] }} className='w-full h-full' />
          <div className='w-full text-black rounded-md font-bold text-center text-sm 2xl:text-md' style={{ backgroundColor: colors[generatorItem.status] }}>
            {generatorItem.status}
          </div>
        </div>
        <div className='flex flex-col items-center -mt-1 2xl:mt-0'>
          <p className='text:md 2xl:text-xl'>{generatorItem.data.heading}</p>
          <p className='text:xl 2xl:text-3xl font-bold'>{generatorItem.data.level}</p>
          <p className='text:md 2xl:text-xl'>{generatorItem.data.capacity}</p>
        </div>
        <div>
          <PercentageBar percentage={parsePercentage(generatorItem.data.level)} />
        </div>
      </div>
    </div>
  );
};

export default GeneratorCard;